import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, InputAdornment, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddCustomerForm from "./AddCustomerForm";
import CustomerCard from "./Permissions/CustomerCard";
import translations from '../translations/customersTranslation';
import { isTestEnv } from "../globals";

const Customer = ({ setMockDropdownData, setSnackbar, mockDropdownData, execute }) => {
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        const customersResponse = await execute(
          "POST",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/allCustomers`
        );
        setCustomers(customersResponse);
      } catch (err) {
        isTestEnv && console.error(err);
      }
    };
    getData();
  }, []);

  const handleDeleteCustomer = async (id) => {
    const isSure = window.confirm(translations.areYouSureDeleteCustomer);
    if (isSure) {
      try {
        await execute(
          "DELETE",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/customers/deleteCustomer/${id}`
        );
        setCustomers(customers.filter((c) => c._id !== id));
        setMockDropdownData((prev) => ({
          ...prev,
          receiveCustomer: mockDropdownData.receiveCustomer.filter((c) => c._id !== id),
        }));
        setMockDropdownData((prev) => ({
          ...prev,
          ordererCustomer: mockDropdownData.ordererCustomer.filter((c) => c._id !== id),
        }));
        setSnackbar({ open: true, message: translations.customerDeletedSuccess, severity: "success" });
      } catch (error) {
        isTestEnv && console.error(error);
        setSnackbar({ open: true, message: translations.errorOccurred, severity: "error" });
      }
    }
  };

  const filteredCustomers = customers.filter((c) => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    return c.custdes?.toLowerCase().includes(term) || c.custname?.toLowerCase().includes(term);
  });

  return (
    <Box mt={2}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>{translations.customers}</Typography>
      <Box sx={{ mb: 2 }}>
        <AddCustomerForm
          setCustomers={setCustomers}
          customers={customers}
          setMockDropdownData={setMockDropdownData}
        />
      </Box>

      <Box sx={{ mb: 3 }}>
        <TextField
          placeholder="חיפוש לקוח..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: 300 }}
        />
      </Box>

      <Grid container spacing={3}>
        {filteredCustomers.map((rc) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={rc._id}>
            <CustomerCard customer={rc} onDelete={handleDeleteCustomer} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Customer;
